module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "container"
  }, _vm._l((_vm.confsMobile), function(conf, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": conf.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": conf.img,
        "alt": ""
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6edadf84","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/confs/confs.vue
// module id = 459
// module chunks = 1